/* eslint-disable */
import React, { useState, useEffect, useContext, useMemo } from "react";

import { Link } from "react-router-dom";

import { MaterialReactTable } from "material-react-table";
import { defaultTableConfig, withStrictFilter } from "Config/tableConfig";
import * as XLSX from "xlsx";

//api url requirement
import * as url from "urlhelpers/UrlHelper";
import { getData } from "utils/Gateway";

//import context
import { GlobalProvider } from "context/GlobalContext";

//import translation function for language translation
import { useTranslation } from "react-i18next";

const ConceptList = ({
  downloadExcel,
  search,
  setRecords,
  checkedRecordCount,
}) => {
  const token = localStorage.getItem("token"); // token
  const { t } = useTranslation(); //for translation

  const {
    reloadConceptList,
    setReloadConceptList,
    setEditConceptData,
    screenHeight,
  } = useContext(GlobalProvider);

  const [conceptList, setConceptList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [rowSelection, setRowSelection] = useState({});
  const [columnFilters, setColumnFilters] = useState([]);

  const getSelectedData = () => {
    const selectedIds = Object.keys(rowSelection).filter((key) => rowSelection[key]);
    return conceptList.filter((item) => selectedIds.includes(item._id));
  };

  /* Handle the button's onClick event and set it to export the data by using the ExcelExport save method. */
  const exportExcel = () => {
    const selectedData = getSelectedData();
    const exportData = selectedData.length > 0 ? selectedData : conceptList;
    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, "Concept.xlsx");
  };

  /* function to get all concept data */
  const getAllConceptList = async (currentSearch = search) => {
    setIsLoading(true);
    try {
      let requestUrl =
        url.API_BASEURL + url.API_GET_ALL_CONCEPT + `?token=${token}`;

      if (currentSearch?.trim()) {
        requestUrl += `&globalsearch=${encodeURIComponent(currentSearch.trim())}`;
      }

      console.log("concept list url =====>>>", requestUrl);

      const response = await getData(requestUrl);

      console.log("concept list response ========>>>", response);

      if (response.data) {
        setConceptList(response.data);
        setRecords(response.data.length);
      }
    } catch (error) {
      console.error(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  /* custom title html */
  const titleHtml = ({ dataItem }) => {
    return (
      <div className="title">
        <div className="d-flex align-items-center gap-2">
          <span>{dataItem.name}</span>
          <Link
            to="#addUpdateConceptPopup"
            data-bs-toggle="offcanvas"
            className="ml-auto edit_icon"
          >
            <span
              className="d-block material-symbols-outlined icon-md"
              onClick={() => {
                setEditConceptData(dataItem);
              }}
            >
              edit
            </span>
          </Link>
        </div>
      </div>
    );
  };

  const tableColumns = useMemo(
    () => withStrictFilter([
      {
        id: "name",
        accessorKey: "name",
        header: t("Title"),
        Cell: ({ row }) => titleHtml({ dataItem: row.original }),
        size: 200,
      },
      {
        id: "conceptdate",
        accessorKey: "conceptdate",
        header: t("Date"),
        size: 200,
      },
    ]),
    [t, conceptList]
  );

  /* hook to reload list */
  useEffect(() => {
    if (reloadConceptList) {
      getAllConceptList();
      setReloadConceptList(false);
    }
  }, [reloadConceptList]);

  /* initial load + refetch when search changes */
  useEffect(() => {
    getAllConceptList(search);
  }, [search]);

  /* hook to hit exportExcel() function */
  useEffect(() => {
    downloadExcel && exportExcel();
  }, [downloadExcel]);

  /* set records based on conceptList */
  useEffect(() => {
    setRecords(conceptList.length);
  }, [conceptList]);

  /* sync selected count to parent */
  useEffect(() => {
    const selectedCount = Object.keys(rowSelection).filter((key) => rowSelection[key]).length;
    checkedRecordCount(selectedCount);
  }, [rowSelection, conceptList]);

  /* Reset selection when concept list changes (after delete/reload) */
  useEffect(() => {
    setRowSelection({});
  }, [conceptList]);

  return (
    <div className="activity_table">
      {/* Hidden checkboxes so ConceptHeader deleteConceptHandler can detect selected rows */}
      <div style={{ display: "none" }}>
        {conceptList.map((concept) => (
          <input
            key={concept._id}
            type="checkbox"
            name="selectConceptRecord"
            value={concept._id}
            checked={!!rowSelection[concept._id]}
            onChange={() => {}}
          />
        ))}
      </div>
      <div className="table-responsive">
        <MaterialReactTable
          {...defaultTableConfig}
          enableGlobalFilter
          globalFilterFn="strictContains"
          columns={tableColumns}
          data={conceptList}
          enableSorting
          enableGrouping
          enableColumnOrdering
          enableStickyHeader
          enableRowSelection
          onRowSelectionChange={setRowSelection}
          onColumnFiltersChange={setColumnFilters}
          getRowId={(row) => row._id}
          state={{ rowSelection, columnFilters, isLoading }}
          renderLoadingOverlay={() => null}
          muiLinearProgressProps={{ sx: { display: "none" } }}
          muiCircularProgressProps={{ sx: { display: "none" } }}
          muiTableContainerProps={{ sx: { maxHeight: screenHeight } }}
          muiTableBodyRowProps={{ sx: { overflow: "visible" } }}
          muiTableBodyProps={{ sx: { overflow: "visible" } }}
        />
      </div>
    </div>
  );
};

export default ConceptList;
